/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 08:53:21
 * @LastEditTime: 2020-09-09 14:15:33
 * @Description: 客户api
 */
import axios from '@/utils/axios'

export const getCustomerList = (payload) => {
    return axios.get('/customer', {
        params: payload
    })
}

export const getCustomerSimpleList = (payload) => {
    return axios.get('/customer_simple_list', {
        params: payload
    })
}

export const getAllCustomerList = (payload) => {
    return axios.get('/all_customer_list', {
        params: payload
    })
}

export const getUserCustomerRolesCount = (payload) => {
    return axios.get('/user_customer_roles_count', {
        params: payload
    })
}

export const getCustomerById = (id) => {
    return axios.get(`/customer/${id}`);
}

export const updateCustomer = (id, data) => {
    return axios.put(`/customer/${id}`, data);
}

export const updateManyCustomer = (data) => {
    return axios.put(`/many_customer`, data);
}

export const deleteCustomer = (id) => {
    return axios.delete(`/customer/${id}`)
}

export const createCustomer = (data) => {
    return axios.post(`/customer`, data)
}

export const getCustomerQZList = (payload) => {
    return axios.get('/customer_qz_list', {
        params: payload
    })
}

export const getCustomerQzById = (id) => {
    return axios.get(`/customer_qz/${id}`);
}

export const reloadCustomerStatus = (data) => {
    return axios.post(`/reload_customer_status`, data)
}

export const getCustomerFullDetailById = (id) => {
    return axios.get(`/customer_full_detail/${id}`);
}